module.exports = __webpack_public_path__ + "static/media/sawat-abstr.8a69b6c5.png";